import { AnyAction } from "redux";

import { GetCustomers, 
    GetUsers, 
    UpdateSearchParams,
    ResetAdminDashboard
 } from '../actions/actionTypes';
import { updateObject } from '../../services/utilService';

import { SortingType, UserTypes, UserColumns } from '../../shared/models/adminModels';

const initialState = {
    userList: {
        recordsTotal: 0,
        currentPage: 1,
        pageSize: 10,
        orderBy: UserColumns.UserName,
        sortType: SortingType.ASC,
        data: [],
        totalPages: 1,
        searchParameter: ''
    },
    customerList: {
        recordsTotal: 0,
        currentPage: 1,
        pageSize: 10,
        orderBy:  UserColumns.CustomerName,
        sortType: SortingType.ASC,
        data: [],
        totalPages: 1,
        searchParameter: ''
    }
};

const getUsers = (state: any, action: any) => {
    const { recordsTotal, pageSize} = action.payload;

    return updateObject(state, { 
        userList: {
            ...state.userList,
            ...action.payload,
            totalPages: recordsTotal ? Math.ceil(recordsTotal/pageSize) : 1
        }
    });
}

const getCustomers = (state: any, action: any) => {
    const { recordsTotal, pageSize} = action.payload;
    
    return updateObject(state, {
        customerList: {
            ...state.customerList,
            ...action.payload,
            totalPages: recordsTotal ? Math.ceil(recordsTotal/pageSize) : 1
        }
    });
}

const updateSearchParams = (state: any, action: any) => {
    const { params, userType } = action.payload;
    
    return userType === UserTypes.USER
        ? updateObject(state, {
            userList: {
                ...state.userList,
                ...params
            }
        })
        : updateObject(state, {
            customerList: {
                ...state.customerList,
                ...params
            }
        });
}

const resetToInitialState = (state: any) => {
    return updateObject(state, initialState);
}

const adminDashboardReducer = (state = initialState, action: AnyAction) => {
    switch(action.type) {
        case GetCustomers: return getCustomers(state, action);
        case GetUsers: return getUsers(state, action);
        case UpdateSearchParams: return updateSearchParams(state, action);
        case ResetAdminDashboard: return resetToInitialState(state);
        default: return state;
    } 
}

export default adminDashboardReducer;